import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import { up } from 'styled-breakpoints';

const Subheader = styled.h3`
    font-size: 1em;
    font-weight: 500;
    text-align: center;
    font-family: 'Gordita';


    ${up('md')} {
        font-size: 1.05em;
    }

    ${up('lg')} {
        font-size: 1.1em;
    }

    ${up('xl')} {
        font-size: 1.2em;
    }

`;

function OnboardingSubheader(props) {
    return (
        <Subheader>{props.text}</Subheader>
    )
}

OnboardingSubheader.propTypes = {
    text: PropTypes.string.isRequired,
};

export default OnboardingSubheader;